import { render, staticRenderFns } from "./ConfigPublish.vue?vue&type=template&id=2f952a24&scoped=true"
import script from "./ConfigPublish.vue?vue&type=script&lang=js"
export * from "./ConfigPublish.vue?vue&type=script&lang=js"
import style0 from "./ConfigPublish.vue?vue&type=style&index=0&id=2f952a24&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f952a24",
  null
  
)

export default component.exports